import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Auth } from "../services/auth/auth.service";

// 他のキャスト・ゲスト等のチェックにも後々する。引数を使う
export const requireRoleAdmin =
  (): CanActivateFn =>
  async (route, state): Promise<boolean> => {
    const auth = inject(Auth);

    return auth.canActAsAdmin();
  };

// 他のキャスト・ゲスト等のチェックにも後々する。引数を使う
export const requireRoleCast =
  (): CanActivateFn =>
  async (route, state): Promise<boolean> => {
    const auth = inject(Auth);

    return auth.canActAsCast();
  };

// 他のキャスト・ゲスト等のチェックにも後々する。引数を使う
export const requireRoleGuest =
  (): CanActivateFn =>
  async (route, state): Promise<boolean> => {
    const auth = inject(Auth);

    return auth.canActAsGuest();
  };
